import $ from "jquery";
import "./../styles/main.scss";
// require("./helpers/ihavecookies");
require("./fragments/WooCommerceActions");
require("./fragments/scrollMove");
require("./pages/presentation");
require("./pages/reservation");
require("./pages/checkout");
require("./pages/order");
require("jquery.scrollto");
$(document).ready(function () {
    // const viewCookieBannerButton = document.querySelector(".view-cookie-banner");
    // if (viewCookieBannerButton !== void 0) {
    //     viewCookieBannerButton.addEventListener("click", (e) => {
    //         e.preventDefault();
    //         CookieConsentNode.showDetails();
    //     });
    // }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").innerHeight() + 100;
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    if (location.hash !== void 0) {
        var node = location.hash;
        if (node != "") {
            var posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    }
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
});
